module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/13.5dd4b173.jpg";